<template>
    <div class="container-fluid">
        <div class="page-title-sec">
            <h3>Macroactive First XV - Lives Changed</h3>
            <button class="btn btn-primary" @click="exportReport">
                Export CSV
            </button>
        </div>

        <list-filter @submit="filterSubmit"></list-filter>

        <div class="card mt-3 pt-4">
            <div class="container-fluid">
                <div v-if="livesChangedTotalCount > 0">
                    <paginator :rowCount="livesChangedTotalCount"
                               :perPage="paginationPerPage"
                               :currentPage="paginationCurrentPage"
                               @pageChanged="pageChanged"
                               @perPageChanged="perPageChanged"></paginator>
                    <list-table :livesChanged="livesChanged" :livesChangedTotals="livesChangedTotals"></list-table>
                    <paginator :rowCount="livesChangedTotalCount"
                               :perPage="paginationPerPage"
                               :currentPage="paginationCurrentPage"
                               @pageChanged="pageChanged"
                               @perPageChanged="perPageChanged"></paginator>
                </div>
                <div class="pb-4 text-center" v-else>
                    <p>No records found.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ListFilter from './includes/ListFilter'
import ListTable from './includes/ListTable'
import Paginator from '../includes/pagination/Paginator'
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: 'MainPage',
  components: {
    ListTable,
    ListFilter,
    Paginator
  },
  computed: {
    ...mapGetters({
      livesChangedTotals: 'livesChangedDaily/getLivesChangedTotals',
      livesChanged: 'livesChangedDaily/getLivesChanged',
      livesChangedTotalCount: 'livesChangedDaily/getLivesChangedTotalCount',
      paginationCurrentPage: 'livesChangedDaily/getPaginationCurrentPage',
      paginationPerPage: 'livesChangedDaily/getPaginationPerPage'
    })
  },
  mounted () {
    this.loadLivesChanged()
    this.loadLivesChangedTotals()
  },
  methods: {
    ...mapMutations({
      setPaginationActivePage: 'livesChangedDaily/setPaginationActivePage',
      setPaginationPerPage: 'livesChangedDaily/setPaginationPerPage'
    }),
    ...mapActions({
      loadLivesChanged: 'livesChangedDaily/loadData',
      loadLivesChangedTotals: 'livesChangedDaily/loadTotals',
      downloadReport: 'livesChangedDaily/downloadReport'
    }),
    exportReport () {
      this.downloadReport()
    },
    perPageChanged (perPage) {
      this.setPaginationPerPage(perPage)
      this.loadLivesChanged()
      this.loadLivesChangedTotals()
    },
    pageChanged (page) {
      this.setPaginationActivePage(page)
      this.loadLivesChanged()
      this.loadLivesChangedTotals()
    },
    filterSubmit () {
      this.setPaginationActivePage(1)
      this.loadLivesChanged()
      this.loadLivesChangedTotals()
    }
  }
}
</script>

<style scoped>

</style>
